import OptionService from "./../../../services/OptionService";

export default {
  namespaced: true,
  state: {
    optionList: [],
    inputList: [],
    option: {},
    lang: null
  },
  mutations: {
    setOptionList: (state, list) => {
      state.optionList = list;
    },
    setInputList: (state, list) => {
      state.inputList = list;
    },
    setOption: (state, data) => {
      state.option = data;
    },
    setLang: (state, data) => {
      state.lang = data;
    }
  },
  actions: {
    getOptionList: ({ commit, state }, params) => {
      const { lang } = state;
      return new Promise((resolve, reject) => {
        OptionService.optionList({ ...params, lang })
          .then(res => {
            commit("setOptionList", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getInputList: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        OptionService.inputList(params)
          .then(res => {
            commit("setInputList", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    option: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        OptionService.option(params)
          .then(res => {
            commit("setOption", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    option_l: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        OptionService.option_l(params)
          .then(res => {
            commit("setOption", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateInputList: ({ dispatch }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.updateInputList(optionData)
          .then(res => {
            dispatch("option", optionData.optionSysName);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    addOption: ({ dispatch, state }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.addOption(optionData)
          .then(res => {
            dispatch("getOptionList");
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateOption: ({ dispatch, state }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.updateOption(optionData)
          .then(res => {
            dispatch("getOptionList");
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    deleteOption: ({ dispatch, state }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.deleteOption(optionData)
          .then(res => {
            dispatch("getOptionList");
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateOptionsQueue: ({ dispatch }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.updateOptionsQueue(optionData)
          .then(res => {
            dispatch("getOptionList");
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateInputsQueue: ({ commit }, inputList) => {
      return new Promise((resolve, reject) => {
        OptionService.updateInputsQueue(inputList)
          .then(res => {
            if (res.status === 200) {
              commit("setInputList", res.data);
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
